import { render, staticRenderFns } from "./DictChoose.vue?vue&type=template&id=75361411&scoped=true"
import script from "./DictChoose.vue?vue&type=script&lang=js"
export * from "./DictChoose.vue?vue&type=script&lang=js"
import style0 from "./DictChoose.vue?vue&type=style&index=0&id=75361411&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75361411",
  null
  
)

export default component.exports